var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrowth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wallet arrow up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combo shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9998 0.333313H6.99982C5.8807 0.333313 4.92259 1.0227 4.527 1.99998H13.4727C13.0771 1.0227 12.1189 0.333313 10.9998 0.333313ZM0.333328 9.66665L0.333328 6.99998H3C3.73637 6.99998 4.33333 7.59693 4.33333 8.33331C4.33333 9.06969 3.73637 9.66665 3 9.66665H0.333328ZM2.99999 2.99998H13.6667V7.99998C13.6667 8.55226 13.2189 8.99998 12.6667 8.99998H12.0667C10.0048 8.99998 8.33333 10.6715 8.33333 12.7333C8.33333 13.2488 7.91546 13.6666 7.39999 13.6666H2.99999C1.52724 13.6666 0.333328 12.4727 0.333328 11V10.6666H3C4.28866 10.6666 5.33333 9.62198 5.33333 8.33331C5.33333 7.04465 4.28866 5.99998 2.99999 5.99998H0.333328V5.66665C0.333328 4.19389 1.52724 2.99998 2.99999 2.99998ZM10.6869 11.7441L11.1667 11.2643V13.6666C11.1667 13.9428 11.3905 14.1666 11.6667 14.1666C11.9428 14.1666 12.1667 13.9428 12.1667 13.6666V11.2643L12.6464 11.7441C12.8417 11.9393 13.1583 11.9393 13.3535 11.7441C13.5488 11.5488 13.5488 11.2322 13.3535 11.037L12.4916 10.175C12.036 9.71941 11.2973 9.71941 10.8417 10.175L9.97977 11.037C9.78451 11.2322 9.78451 11.5488 9.97977 11.7441C10.175 11.9393 10.4916 11.9393 10.6869 11.7441Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowth);
export default __webpack_public_path__ + "static/media/growth.6cb3faeca04c31b4fa69fe50f6c5992a.svg";
export { ForwardRef as ReactComponent };